import React, {FC} from 'react';
import styled from 'styled-components';

import {ChannelModel} from '../../../../../models/api/channelModel';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {ConversationSafetyNetModel} from '../../../../../models/api/conversationSafetyNetModel';
import {InboxModel} from '../../../../../models/api/inboxModel';
import {ConversationSummaryChannels} from './conversationSummaryChannels';
import {ConversationSummaryConversationId} from './conversationSummaryConversationId';
import {ConversationSummaryInboxes} from './conversationSummaryInboxes';
import {ConversationSummarySafetyNets} from './conversationSummarySafetyNets';
import {ConversationSummarySectionsEnum} from './conversationSummarySections';

/*
 * Props.
 */

interface ConversationSummaryDetailsProps {
  conversation: ConversationModel;
  host: string;
  inboxes: ReadonlyArray<InboxModel>;
  channels: ReadonlyArray<ChannelModel>;
  safetyNets: ReadonlyArray<ConversationSafetyNetModel>;
}

/*
 * Style.
 */

const StyledAdvancedSectionContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 7px;
`;

/*
 * Component.
 */

export const ConversationSummaryDetails: FC<ConversationSummaryDetailsProps> = ({
  host,
  conversation,
  channels,
  inboxes,
  safetyNets,
}) => (
  <StyledAdvancedSectionContainerDiv data-testid={ConversationSummarySectionsEnum.DETAILS}>
    <ConversationSummaryConversationId host={host} conversation={conversation} />
    <ConversationSummaryChannels channels={channels} />
    <ConversationSummaryInboxes inboxes={inboxes} />
    <ConversationSummarySafetyNets safetyNets={safetyNets} />
  </StyledAdvancedSectionContainerDiv>
);
